import loginReducer from './login';
export * from './login';

export default { login: loginReducer };
